import state from './moduloRepositoryRulesState';
import mutations from './moduloRepositoryRulesMutations';
import * as actions from './moduloRepositoryRulesActions';
import * as getters from './moduloRepositoryRulesGetters';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
